import * as actionTypes from './../actions/weeksLitterAction';
import * as animalTypes from './../../containers/AnimalType/AnimalTypeValues'

const initialState = {
  selectedWeeks: null,
  selectedLitter: null,
  pregnancyFactorId: null,
  lactationFactorId: null,
  sterilisedFactorId: null,
  data: [],
  pending: true,
  error: null,
  ready: false,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SELECT_WEEKS:
      return {
        ...state,
        selectedWeeks: action.selectedWeeks
      };
    case actionTypes.SELECT_LITTER:
      return {
        ...state,
        selectedLitter: action.selectedLitter
      };
    case actionTypes.SET_PREGNANCY:
      let pregnancy = null;
      if(action.pregnancyFactorId && action.selectedAnimalType === animalTypes.CAT){
        pregnancy = state.data["pregnancyFactorCat"][action.pregnancyFactorId];
      }
      else if(action.pregnancyFactorId && action.selectedAnimalType === animalTypes.DOG){
        pregnancy = state.data["pregnancyFactorDog"][action.pregnancyFactorId];
      }
      return {
        ...state,
        pregnancyFactorId: pregnancy,
      };
    case actionTypes.SET_LACTATION:
      let lactation = null;
      if(action.lactationFactorId && action.selectedAnimalType === animalTypes.CAT){
        lactation = state.data["lactationFactorCat"][action.lactationFactorId];
      }
      else if(action.lactationFactorId && action.selectedAnimalType === animalTypes.DOG){
        lactation = state.data["lactationFactorDog"][action.lactationFactorId];
      }
      return {
        ...state,
        lactationFactorId: lactation,
      };
    case actionTypes.SET_STERILISED:
      return {
        ...state,
        sterilisedFactorId: state.data.sterilisedFactor[action.sterilisedFactorId],
      };
    case actionTypes.DEFAULT:
      let pregnancyId = null;
      if(action.selectedAnimalType === animalTypes.CAT){
        pregnancyId = state.data["pregnancyFactorCat"][1];
      }
      else if(action.selectedAnimalType === animalTypes.DOG){
        pregnancyId = state.data["pregnancyFactorDog"][1];
      }
      let lactationId = null;
      if(action.selectedAnimalType === animalTypes.CAT){
        lactationId = state.data["lactationFactorCat"][1];
      }
      else if(action.selectedAnimalType === animalTypes.DOG){
        lactationId = state.data["lactationFactorDog"][1];
      }
      return {
        ...state,
        selectedWeeks: 1,
        selectedLitter: 5,
        pregnancyFactorId: pregnancyId,
        lactationFactorId: lactationId,
        sterilisedFactorId: state.data.sterilisedFactor[0],
        ready: true,
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
